/**
 * Keeps the product-card color text (rendered by a Custom Liquid block as
 * <p class="gb-variant-color-text">) in sync with whichever Swatch King
 * swatch is selected, site-wide.
 *
 * Loaded once globally (from layout/theme.liquid) rather than inlined in
 * the Custom Liquid block itself, because this theme uses client-side
 * "soft" navigation (view-transitions.js) between pages - content swapped
 * in that way does not execute embedded <script> tags the way a full page
 * load does.
 *
 * Swatch King does not dispatch the theme's variant:update event, so this
 * reads the color name directly off the clicked swatch instead: each
 * swatch renders as <li class="swatch-view-item" orig-value="Brown"
 * aria-label="Brown" role="radio" ...>.
 *
 * The swatch block and the color-text Custom Liquid block are SIBLING
 * blocks inside a shared <div class="group-block-content"> wrapper (not
 * <product-card>), confirmed via devtools.
 *
 * ROOT CAUSE (confirmed via console testing): Swatch King's own click
 * handler on the swatch stops the click event from bubbling
 * (event.stopPropagation()), so a plain document.addEventListener('click', ...)
 * in the default bubble phase NEVER fires for swatch clicks at all - it's
 * not a timing race, the handler simply never runs. Capture-phase
 * listeners (the 3rd argument `true`) fire BEFORE the target's own
 * handlers, so they see the click regardless of any later
 * stopPropagation() call. That's why every earlier console test that used
 * capture:true "worked" while the production script (bubble phase)
 * silently did nothing. Fix: attach both listeners in the capture phase.
 */
(function () {
  if (window.__gbVariantColorTextInit) return;
  window.__gbVariantColorTextInit = true;

  function closestAcrossShadow(el, selector) {
    var node = el;
    while (node) {
      if (node instanceof Element && node.matches && node.matches(selector)) {
        return node;
      }
      var root = node.getRootNode ? node.getRootNode() : null;
      node = node.parentElement || (root && root.host) || null;
    }
    return null;
  }

  function findCard(el) {
    return (
      closestAcrossShadow(el, '.group-block-content') ||
      closestAcrossShadow(el, 'product-card') ||
      closestAcrossShadow(el, '[data-product-handle]')
    );
  }

  function findSwatchItemFromEvent(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node instanceof Element && node.classList && node.classList.contains('swatch-view-item')) {
        return node;
      }
    }
    return null;
  }

  function handleSwatchInteraction(event) {
    var swatchItem = findSwatchItemFromEvent(event);
    if (!swatchItem) return;

    var colorText = swatchItem.getAttribute('orig-value') || swatchItem.getAttribute('aria-label');
    if (!colorText) return;

    var card = findCard(swatchItem);
    if (!card) return;

    var el = card.querySelector('.gb-variant-color-text');
    if (!el) return;

    el.textContent = colorText;
  }

  // Capture phase (true) is required: Swatch King's own click handler
  // stops propagation, so a bubble-phase listener never sees the click.
  document.addEventListener('click', handleSwatchInteraction, true);

  // Swatch King's swatches are role="radio" and keyboard-focusable, so
  // also catch selection via keyboard (Enter/Space) without a real click.
  document.addEventListener(
    'keyup',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      handleSwatchInteraction(event);
    },
    true
  );
})();
